import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

type Size = 'zero' | 'small' | 'medium';
interface DividerProps extends PropsWithChildren {
  size?: Size;
  vertical?: boolean;
}
const Box = styled.div<{
  size: Size;
  $vertical: boolean;
}>`
  width: ${({ $vertical }) => ($vertical ? '1px' : '100%')};
  height: ${({ $vertical }) => ($vertical ? '100%' : '1px')};
  background-color: ${({ theme }) => theme.colors.gray30};
  margin: ${({ size, $vertical }) => {
    switch (size) {
      case 'medium':
        return $vertical ? '0 16px' : '16px 0';
      case 'small':
        return $vertical ? '0 8px' : '8px 0';
      case 'zero':
      default:
        return '0';
    }
  }};
`;

const Divider: React.FC<DividerProps> = ({ size = 'zero', vertical = false, children }) => {
  return (
    <Box size={size} $vertical={vertical}>
      {children}
    </Box>
  );
};

export default Divider;
